import React from 'react';

export const AdvantageIcons: React.ReactElement[] = [
    <svg
        key="advantage-icon-1"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.1001 3.75977V12.2898H19.1001V5.75977H42.2401V28.8998H35.7101V30.8998H44.2401V3.75977H17.1001Z"
            fill="#7829FF"
        />
        <path
            d="M10.5601 10.29V37.44H37.7101V10.29H10.5601ZM35.7101 35.44H12.5601V12.29H35.7101V35.44Z"
            fill="white"
        />
        <path
            d="M30.91 17.0898H3.76001V44.2398H30.91V17.0898Z"
            fill="url(#paint0_linear_186_4616)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_186_4616"
                x1="17.3335"
                y1="17.0013"
                x2="17.3335"
                y2="43.2817"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
        </defs>
    </svg>,
    <svg
        key="advantage-icon-2"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M7.10999 23H2.23999V25H7.10999V23Z" fill="white" />
        <path
            d="M20.6399 6.21973C18.5699 6.21973 16.7599 7.96973 15.4199 10.9097C14.4899 10.0197 13.4399 9.51973 12.3199 9.51973C8.30992 9.51973 5.16992 15.8797 5.16992 23.9997C5.16992 32.1097 8.30992 38.4697 12.3199 38.4697C13.4399 38.4697 14.4899 37.9697 15.4199 37.0797C16.7599 40.0197 18.5699 41.7697 20.6399 41.7697C24.9499 41.7697 28.1899 34.1297 28.1899 23.9997C28.1899 13.8597 24.9499 6.21973 20.6399 6.21973ZM20.6399 39.7697C19.3099 39.7697 17.9099 38.1197 16.8399 35.2897C16.6899 34.8997 16.5499 34.4797 16.4199 34.0397C16.2699 33.5597 16.1299 33.0497 16.0099 32.5197C15.4299 30.1197 15.0799 27.2297 15.0799 23.9997C15.0799 20.7697 15.4299 17.8697 16.0099 15.4697C16.1299 14.9397 16.2699 14.4297 16.4199 13.9497C16.5499 13.5097 16.6899 13.0997 16.8399 12.7097C17.9099 9.86973 19.3099 8.21973 20.6399 8.21973C23.2699 8.21973 26.1899 14.6997 26.1899 23.9997C26.1899 33.2897 23.2699 39.7697 20.6399 39.7697ZM12.3199 36.4697C9.87992 36.4697 7.16992 31.3497 7.16992 23.9997C7.16992 16.6397 9.87992 11.5197 12.3199 11.5197C13.0899 11.5197 13.8899 12.0297 14.6299 12.9597C13.6499 15.9497 13.0799 19.7597 13.0799 23.9997C13.0799 28.2397 13.6499 32.0397 14.6299 35.0297C13.8899 35.9597 13.0899 36.4697 12.3199 36.4697Z"
            fill="#7829FF"
        />
        <path
            d="M30.9199 2.46973C26.7799 2.46973 22.3799 10.0097 22.3799 23.9997C22.3799 37.9897 26.7799 45.5297 30.9199 45.5297C35.0599 45.5297 39.4599 37.9897 39.4599 23.9997C39.4599 10.0097 35.0599 2.46973 30.9199 2.46973Z"
            fill="url(#paint0_linear_186_4595)"
        />
        <path
            d="M40.7299 18.5498L39.3099 19.9598L42.3499 22.9998H30.9199V24.9998H42.3499L39.3099 28.0398L40.7299 29.4498L46.1699 23.9998L40.7299 18.5498Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_186_4595"
                x1="36.8044"
                y1="23.9999"
                x2="17.6563"
                y2="23.9999"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
        </defs>
    </svg>,
    <svg
        key="advantage-icon-3"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M33.2799 44.2999L3.37988 14.3999L14.3999 3.37988L44.2999 33.2799L33.2799 44.2999ZM6.20988 14.3999L33.2799 41.4699L41.4699 33.2799L14.3999 6.20988L6.20988 14.3999Z"
            fill="white"
        />
        <path
            d="M38.2201 20.7895L15.32 43.6895H4.30005V32.6695L27.2001 9.76953L38.2201 20.7895Z"
            fill="url(#paint0_linear_186_4600)"
        />
        <path
            d="M44.4199 14.5903L38.22 20.7903L36.81 19.3803L41.59 14.5903L33.4 6.40031L28.62 11.1903L27.2 9.77031L33.4 3.57031L44.4199 14.5903Z"
            fill="#7829FF"
        />
        <defs>
            <linearGradient
                id="paint0_linear_186_4600"
                x1="4.33655"
                y1="43.6605"
                x2="32.6052"
                y2="15.3918"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
        </defs>
    </svg>,
    <svg
        key="advantage-icon-4"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32.3401 39.2304C32.7101 39.4304 33.0801 39.6003 33.4301 39.7603C32.7201 40.1903 31.9701 40.5804 31.1901 40.9004C30.8101 40.7004 30.4301 40.4903 30.0501 40.2803C25.9201 37.9303 21.4501 34.3604 17.5401 30.4504C16.0001 28.9104 14.5101 27.2704 13.1201 25.6104C11.2701 28.0204 9.81009 30.3103 8.78009 32.3503C8.58009 32.7204 8.41009 33.0803 8.25009 33.4403C7.81009 32.7304 7.43009 31.9904 7.10009 31.2204C7.30009 30.8404 7.51009 30.4503 7.73009 30.0604C8.86009 28.1003 10.2601 26.0504 11.8501 24.0204C10.2501 21.9804 8.85009 19.9304 7.72009 17.9604C7.50009 17.5703 7.29009 17.1804 7.09009 16.8004C7.42009 16.0303 7.80009 15.2804 8.23009 14.5704C8.39009 14.9204 8.57009 15.2904 8.76009 15.6604C9.80009 17.7104 11.2601 20.0004 13.1201 22.4304C14.5101 20.7704 16.0001 19.1304 17.5401 17.5904C21.4701 13.6604 25.9701 10.0804 30.1001 7.73035C30.4901 7.51035 30.8701 7.30035 31.2501 7.11035C32.0201 7.44035 32.7701 7.83035 33.4801 8.26035C33.1301 8.41035 32.7601 8.59035 32.3801 8.79035C28.5301 10.7304 23.7801 14.1804 18.9501 19.0004C17.2601 20.6904 15.7301 22.3804 14.3901 24.0204C15.7301 25.6604 17.2601 27.3504 18.9501 29.0404C23.7601 33.8504 28.4901 37.2803 32.3401 39.2304Z"
            fill="url(#paint0_linear_186_4605)"
        />
        <path
            d="M8.23002 14.57C8.05002 14.19 7.90002 13.81 7.76002 13.45C7.30002 14.15 6.89002 14.88 6.52002 15.65C6.70002 16.03 6.89002 16.41 7.09002 16.8C7.29002 17.18 7.50002 17.57 7.72002 17.96C8.01002 17.16 8.36002 16.4 8.76002 15.66C8.57002 15.29 8.39002 14.92 8.23002 14.57ZM32.4 6.54004C32.02 6.71004 31.64 6.90004 31.25 7.11004C30.87 7.30004 30.49 7.51004 30.1 7.73004C30.89 8.02004 31.65 8.38004 32.38 8.79004C32.76 8.59004 33.13 8.41004 33.48 8.26004C33.87 8.08004 34.24 7.92004 34.6 7.79004C33.9 7.32004 33.16 6.91004 32.4 6.54004ZM33.43 39.76C33.08 39.6 32.71 39.43 32.34 39.23C31.61 39.63 30.84 39.99 30.05 40.28C30.43 40.49 30.81 40.7 31.19 40.9C31.58 41.11 31.98 41.3 32.36 41.48C33.12 41.11 33.85 40.69 34.55 40.23C34.19 40.1 33.81 39.94 33.43 39.76ZM7.73002 30.06C7.51002 30.45 7.30002 30.84 7.10002 31.22C6.90002 31.61 6.70002 31.99 6.53002 32.37C6.90002 33.13 7.31002 33.86 7.77002 34.56C7.91002 34.2 8.07002 33.82 8.25002 33.44C8.41002 33.08 8.58002 32.72 8.78002 32.35C8.37002 31.62 8.02002 30.85 7.73002 30.06Z"
            fill="url(#paint1_linear_186_4605)"
        />
        <path
            d="M43.3699 24C43.3699 27.03 42.6699 29.89 41.4299 32.45C41.0599 33.2 40.6499 33.93 40.1899 34.62C38.7199 36.86 36.7999 38.77 34.5499 40.23C34.1899 40.1 33.8099 39.94 33.4299 39.76C33.0799 39.6 32.7099 39.43 32.3399 39.23C28.4899 37.28 23.7599 33.85 18.9499 29.04C17.2599 27.35 15.7299 25.66 14.3899 24.02C15.7299 22.38 17.2599 20.69 18.9499 19C23.7799 14.18 28.5299 10.73 32.3799 8.79004C32.7599 8.59004 33.1299 8.41004 33.4799 8.26004C33.8699 8.08004 34.2399 7.92004 34.5999 7.79004C36.8299 9.25004 38.7399 11.16 40.2099 13.4C40.6699 14.09 41.0799 14.82 41.4399 15.58C42.6799 18.13 43.3699 20.99 43.3699 24Z"
            fill="url(#paint2_linear_186_4605)"
        />
        <path
            d="M32.36 41.4804C29.83 42.6903 26.99 43.3703 24 43.3703C20.99 43.3703 18.14 42.6803 15.6 41.4604C14.85 41.0904 14.12 40.6804 13.43 40.2204C11.17 38.7504 9.24002 36.8204 7.77002 34.5604C7.91002 34.2004 8.07002 33.8203 8.25002 33.4403C8.41002 33.0803 8.58002 32.7203 8.78002 32.3503C9.81002 30.3103 11.27 28.0204 13.12 25.6104C14.51 27.2704 16 28.9104 17.54 30.4504C21.45 34.3604 25.92 37.9303 30.05 40.2803C30.43 40.4903 30.81 40.7004 31.19 40.9004C31.58 41.1104 31.98 41.3004 32.36 41.4804Z"
            fill="url(#paint3_linear_186_4605)"
        />
        <path
            d="M11.8499 24.0204C10.2599 26.0504 8.85988 28.1004 7.72988 30.0604C7.50988 30.4504 7.29988 30.8404 7.09988 31.2204C6.89988 31.6104 6.69988 31.9904 6.52988 32.3704C5.30988 29.8304 4.62988 27.0004 4.62988 24.0004C4.62988 21.0104 5.30988 18.1804 6.51988 15.6504C6.69988 16.0304 6.88988 16.4104 7.08988 16.8004C7.28988 17.1804 7.49988 17.5704 7.71988 17.9604C8.84988 19.9304 10.2499 21.9804 11.8499 24.0204Z"
            fill="url(#paint4_linear_186_4605)"
        />
        <path
            d="M13.4301 40.2195C14.1201 40.6795 14.8501 41.0895 15.6001 41.4595C13.2001 42.5895 11.1401 43.1495 9.47011 43.1495C8.04011 43.1495 6.90011 42.7395 6.08011 41.9095C4.14011 39.9695 4.60011 36.4495 6.53011 32.3695C6.70011 31.9895 6.90011 31.6095 7.10011 31.2195C7.30011 30.8395 7.51011 30.4495 7.73011 30.0595C8.86011 28.0995 10.2601 26.0495 11.8501 24.0195C12.2601 24.5495 12.6801 25.0795 13.1201 25.6095C11.2701 28.0195 9.81011 30.3095 8.78011 32.3495C8.58011 32.7195 8.41011 33.0795 8.25011 33.4395C8.07011 33.8195 7.91011 34.1995 7.77011 34.5595C6.64011 37.3995 6.53011 39.5395 7.49011 40.4995C8.44011 41.4495 10.6001 41.3295 13.4301 40.2195Z"
            fill="white"
        />
        <path
            d="M41.4401 15.5798C41.0801 14.8198 40.6701 14.0898 40.2101 13.3998C41.2901 10.6098 41.3901 8.47985 40.4501 7.53985C39.5001 6.58985 37.4001 6.67985 34.6001 7.78985C34.2401 7.91985 33.8701 8.07985 33.4801 8.25985C33.1301 8.40985 32.7601 8.58985 32.3801 8.78985C28.5301 10.7298 23.7801 14.1798 18.9501 18.9998C17.2601 20.6898 15.7301 22.3798 14.3901 24.0198C13.9501 23.4898 13.5201 22.9598 13.1201 22.4298C14.5101 20.7698 16.0001 19.1298 17.5401 17.5898C21.4701 13.6598 25.9701 10.0798 30.1001 7.72985C30.4901 7.50985 30.8701 7.29985 31.2501 7.10985C31.6401 6.89985 32.0201 6.70985 32.4001 6.53985C36.4501 4.63985 39.9401 4.18985 41.8701 6.12985C43.6401 7.89985 43.4901 11.1698 41.4401 15.5798Z"
            fill="white"
        />
        <path
            d="M32.4 6.54012C32.02 6.71012 31.64 6.90012 31.25 7.11012C30.87 7.30012 30.49 7.51012 30.1 7.73012C25.97 10.0801 21.47 13.6601 17.54 17.5901C16 19.1301 14.51 20.7701 13.12 22.4301C11.26 20.0001 9.80001 17.7101 8.76001 15.6601C8.57001 15.2901 8.39001 14.9201 8.23001 14.5701C8.05001 14.1901 7.90001 13.8101 7.76001 13.4501C9.22001 11.2001 11.14 9.27012 13.38 7.80012C14.07 7.34012 14.8 6.93012 15.55 6.56012C18.11 5.32012 20.97 4.62012 24 4.62012C27.01 4.62012 29.86 5.31012 32.4 6.54012Z"
            fill="url(#paint5_linear_186_4605)"
        />
        <path
            d="M41.87 41.9097C41.01 42.7697 39.84 43.1597 38.46 43.1597C36.72 43.1597 34.63 42.5497 32.36 41.4797C31.98 41.2997 31.58 41.1097 31.19 40.8997C30.81 40.6997 30.43 40.4897 30.05 40.2797C25.92 37.9297 21.45 34.3597 17.54 30.4497C16 28.9097 14.51 27.2697 13.12 25.6097C12.68 25.0797 12.26 24.5497 11.85 24.0197C10.25 21.9797 8.85 19.9297 7.72 17.9597C7.5 17.5697 7.29 17.1797 7.09 16.7997C6.89 16.4097 6.7 16.0297 6.52 15.6497C4.6 11.5697 4.14 8.0597 6.08 6.1297C7.86 4.3497 11.13 4.4997 15.55 6.5597C14.8 6.9297 14.07 7.3397 13.38 7.7997C10.58 6.7097 8.43 6.5997 7.49 7.5397C6.53 8.4997 6.64 10.6197 7.76 13.4497C7.9 13.8097 8.05 14.1897 8.23 14.5697C8.39 14.9197 8.57 15.2897 8.76 15.6597C9.8 17.7097 11.26 19.9997 13.12 22.4297C13.52 22.9597 13.95 23.4897 14.39 24.0197C15.73 25.6597 17.26 27.3497 18.95 29.0397C23.76 33.8497 28.49 37.2797 32.34 39.2297C32.71 39.4297 33.08 39.5997 33.43 39.7597C33.81 39.9397 34.19 40.0997 34.55 40.2297C37.37 41.3597 39.49 41.4597 40.45 40.4997C41.39 39.5597 41.28 37.4197 40.19 34.6197C40.65 33.9297 41.06 33.1997 41.43 32.4497C43.49 36.8697 43.65 40.1297 41.87 41.9097Z"
            fill="#7829FF"
        />
        <defs>
            <linearGradient
                id="paint0_linear_186_4605"
                x1="7.09249"
                y1="24.0101"
                x2="33.4824"
                y2="24.0101"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8F6AFF" />
                <stop offset="1" stopColor="#4589FC" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_186_4605"
                x1="6.52242"
                y1="24.0147"
                x2="34.6023"
                y2="24.0147"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8F6AFF" />
                <stop offset="1" stopColor="#4589FC" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_186_4605"
                x1="4.56579"
                y1="24.0147"
                x2="42.0133"
                y2="24.0147"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_186_4605"
                x1="4.56592"
                y1="34.4952"
                x2="42.0134"
                y2="34.4952"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_186_4605"
                x1="4.56578"
                y1="24.0151"
                x2="42.0133"
                y2="24.0151"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_186_4605"
                x1="4.56591"
                y1="13.5299"
                x2="42.0134"
                y2="13.5299"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
        </defs>
    </svg>,
    <svg
        key="advantage-icon-5"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M42.44 30.7498C42.26 30.4398 42.0401 30.1398 41.8 29.8498C41.59 29.5798 41.35 29.3198 41.09 29.0598C40.8301 29.6398 40.44 30.2098 39.94 30.7498C40.18 30.9998 40.39 31.2598 40.57 31.5298C40.7701 31.8198 40.9501 32.1298 41.09 32.4398C41.32 32.9898 41.4501 33.5498 41.4501 34.1298C41.4501 38.7098 33.46 42.5898 24 42.5898C14.54 42.5898 6.55005 38.7098 6.55005 34.1298C6.55005 33.5598 6.67005 32.9998 6.91005 32.4498C7.05005 32.1398 7.22005 31.8298 7.43005 31.5298C7.61005 31.2598 7.82005 30.9998 8.06005 30.7498C7.56005 30.2098 7.17005 29.6398 6.91005 29.0498C6.65005 29.3098 6.41005 29.5798 6.20005 29.8498C5.96005 30.1398 5.74005 30.4398 5.56005 30.7498C4.90005 31.7998 4.55005 32.9398 4.55005 34.1298C4.55005 39.9898 13.09 44.5898 24 44.5898C34.9 44.5898 43.4501 39.9898 43.4501 34.1298C43.4501 32.9398 43.1 31.7998 42.44 30.7498Z"
            fill="#7829FF"
        />
        <path
            d="M43.4501 20.6202C43.4501 14.7502 34.9 10.1602 24 10.1602C13.09 10.1602 4.55005 14.7502 4.55005 20.6202C4.55005 21.8102 4.90005 22.9402 5.55005 24.0002C4.90005 25.0502 4.55005 26.1902 4.55005 27.3702C4.55005 28.5602 4.90005 29.7002 5.56005 30.7502C5.92005 31.3402 6.37005 31.9102 6.91005 32.4502C10.18 35.6802 16.54 37.8302 24 37.8302C31.46 37.8302 37.8301 35.6802 41.09 32.4402C41.6301 31.9002 42.08 31.3402 42.44 30.7502C43.1 29.7002 43.4501 28.5602 43.4501 27.3702C43.4501 26.1902 43.1001 25.0502 42.4501 24.0002C43.1001 22.9402 43.4501 21.8102 43.4501 20.6202ZM41.4501 27.3702C41.4501 27.9502 41.32 28.5102 41.09 29.0602C40.8301 29.6402 40.44 30.2102 39.94 30.7502C37.19 33.7102 31 35.8302 24 35.8302C17 35.8302 10.81 33.7102 8.06005 30.7502C7.56005 30.2102 7.17005 29.6402 6.91005 29.0502C6.67005 28.5002 6.55005 27.9402 6.55005 27.3702C6.55005 26.8002 6.67005 26.2402 6.91005 25.6902C10.18 28.9302 16.54 31.0802 24 31.0802C31.46 31.0802 37.8301 28.9202 41.09 25.6802C41.32 26.2302 41.4501 26.7902 41.4501 27.3702ZM40.57 23.2102C40.39 23.4802 40.18 23.7402 39.93 24.0002C37.18 26.9602 30.99 29.0802 24 29.0802C17.01 29.0802 10.82 26.9602 8.07005 24.0002C7.82005 23.7402 7.61005 23.4802 7.43005 23.2102C7.22005 22.9102 7.05005 22.6102 6.91005 22.3002C6.67005 21.7502 6.55005 21.1902 6.55005 20.6202C6.55005 16.0302 14.54 12.1602 24 12.1602C33.46 12.1602 41.4501 16.0302 41.4501 20.6202C41.4501 21.2002 41.32 21.7602 41.09 22.3102C40.9501 22.6102 40.78 22.9202 40.57 23.2102Z"
            fill="white"
        />
        <path
            d="M24 24.3302C34.742 24.3302 43.4501 19.6471 43.4501 13.8702C43.4501 8.09326 34.742 3.41016 24 3.41016C13.2581 3.41016 4.55005 8.09326 4.55005 13.8702C4.55005 19.6471 13.2581 24.3302 24 24.3302Z"
            fill="url(#paint0_linear_186_4591)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_186_4591"
                x1="24"
                y1="3.40856"
                x2="24"
                y2="25.096"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
        </defs>
    </svg>,
    <svg
        key="advantage-icon-6"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M31.1701 20.2998L21.0801 34.8098L15.4401 28.8598L5.56006 43.2098H44.9201L31.1701 20.2998Z"
            fill="url(#paint0_linear_186_4578)"
        />
        <path
            d="M14.56 38.8207H3.94995V28.2207H5.94995V36.8207H14.56V38.8207Z"
            fill="white"
        />
        <path
            d="M38.84 38.8207H28.23V36.8207H36.84V28.2207H38.84V38.8207Z"
            fill="white"
        />
        <path
            d="M5.94995 14.5404H3.94995V3.94043H14.56V5.94043H5.94995V14.5404Z"
            fill="white"
        />
        <path
            d="M38.84 14.5404H36.84V5.94043H28.23V3.94043H38.84V14.5404Z"
            fill="white"
        />
        <path
            d="M16.8201 21.7798C14.0801 21.7798 11.8501 19.5498 11.8501 16.8098C11.8501 14.0698 14.0801 11.8398 16.8201 11.8398C19.5601 11.8398 21.7901 14.0698 21.7901 16.8098C21.7901 19.5498 19.5601 21.7798 16.8201 21.7798ZM16.8201 13.8398C15.1801 13.8398 13.8501 15.1698 13.8501 16.8098C13.8501 18.4498 15.1801 19.7798 16.8201 19.7798C18.4601 19.7798 19.7901 18.4498 19.7901 16.8098C19.7901 15.1698 18.4601 13.8398 16.8201 13.8398Z"
            fill="#7829FF"
        />
        <defs>
            <linearGradient
                id="paint0_linear_186_4578"
                x1="5.56066"
                y1="31.7548"
                x2="44.9207"
                y2="31.7548"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7B4EFF" />
                <stop offset="0.5072" stopColor="#E49599" />
                <stop offset="1" stopColor="#F5C795" />
            </linearGradient>
        </defs>
    </svg>,
];
